import { html } from 'fxjs/es';

/**
 * @param {string} title
 * @param {string} description
 * @param {string?} klass
 * @param {boolean=true} is_absolute
 */
export const emptyTmpl = ({ title, description, klass, is_absolute = true } = {}) => {
  return html`<div class="ness-empty-screen ${klass || ''}" data-is_absolute="${is_absolute}">
    <span class="ness-empty-screen__title">${title}</span>
    <span class="ness-empty-screen__description">${description}</span>
  </div>`;
};
